<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
  import enUs from 'ant-design-vue/lib/locale-provider/en_US';
  import {
    logout
  } from '@/api/login.api';
  export default {
    name: 'App',
    data() {
      return {
        locale: zhCN,
        idleTimeout: null,
        clickTime: null,
        idleDelay: 15 * 60 * 1000 // 15分钟的毫秒数，即900000毫秒
        // idleDelay: 10 * 1000, // 10秒钟退出登录
      }
    },
    watch: {
      userLang(newVal, oldVal) {
        // if (newVal === 'zh-CN') {
        //   this.locale = zhCN
        // } else {
        //   this.locale = enUs
        // }
      }
    },
    computed: {
      // userLang() {
      //   return this.$store.getters.userLang
      // }
    },
    mounted() {
      if(process.env.NODE_ENV != 'development') {
        // 页面创建时开始计时
        this.clickTime = new Date().getTime();
        // 监听用户的鼠标移动事件
        window.addEventListener('mousemove', this.resetTime); // 方法1
        // 监听用户的键盘输入事件
        window.addEventListener('keypress', this.resetTime); // 方法1
        window.requestAnimationFrame(this.step); // 方法1
        // this.startIdleTimeout(); // 方法2
      } else {
        console.log('process.env.NODE_ENV == "development" 不加定时');
      }
      // if (localStorage.getItem('lang') === 'zh-CN') {
      //   this.locale = zhCN
      // } else {
      //   this.locale = enUs
      // }
    },
    methods: {
      resetTime() {
        this.clickTime = new Date().getTime();
      },
      step() {
        let nowTime = new Date().getTime();
        if(nowTime - this.clickTime >= this.idleDelay) {
          // 清除事件监听
          window.removeEventListener('mousemove', this.resetTime);
          window.removeEventListener('keypress', this.resetTime);
          logout().then(res => {
            // 刷新页面
            window.location.reload();
          })
        } else {
          window.requestAnimationFrame(this.step);
        }
      },
      startIdleTimeout() {
        // 设置定时器，如果在15分钟内没有任何操作，则执行onIdle()
        this.idleTimeout = setTimeout(this.onIdle, this.idleDelay);

        // 监听用户的鼠标移动事件
        window.addEventListener('mousemove', this.resetIdleTimeout);
        // 监听用户的键盘输入事件
        window.addEventListener('keypress', this.resetIdleTimeout);
      },
      resetIdleTimeout() {
        // 如果用户进行了操作，清除定时器并重置计时
        console.log('清除定时器并重置计时');
        clearTimeout(this.idleTimeout);
        this.startIdleTimeout();
      },
      onIdle() {
        // 用户15分钟内无操作，执行登出逻辑
        console.log('用户15分钟内无操作，执行登出');
        // 清除事件监听
        window.removeEventListener('mousemove', this.resetIdleTimeout);
        window.removeEventListener('keypress', this.resetIdleTimeout);
        // 执行登出逻辑，如调用API登出并跳转到登录页面等
        logout().then(res => {
          // 刷新页面
          window.location.reload();
        })
      }
    },
    destroyed() {
      // 清除定时器，防止内存泄露
      clearTimeout(this.idleTimeout);
    }
  }
</script>

<style>
  #app {
    height: 100%;
  }

  .span_btn {
    color: #40a9ff;
    cursor: pointer;
  }

  .span_btn_del {
    color: #ff4d4f;
    cursor: pointer;
  }

  .ant-divider,
  .ant-divider-vertical {
    margin: 0 4px;
  }

  a.danger {
    color: #ff4d4f !important;
  }

  a.danger:hover {
    color: #ff7875 !important;
  }

  /* VendorRegisterForm.vue 页面样式 */
  .long_name .ant-select-dropdown-menu-item {
    white-space: unset !important;
    text-overflow: unset !important;
  }

  /* /deep/.ant-table-thead>/deep/tr>/deep/th,
  /deep/.ant-table-tbody>/deep/tr>/deep/td {
    padding: 4px 6px !important;
    font-size: 12px !important;
  } */
</style>



// WEBPACK FOOTER //
// src/App.vue